module.exports = __webpack_public_path__ + "static/media/mrclean.cd4fa003.png";